import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { BaseMapper } from '../../base.mapper';
import { NotificationUnreadModel } from '../../../models/apis/system/notification/notification-unread.model';
import { NotificationUnreadHttp } from '../../../http-models/systems/notification/notification-unread.http';

@Injectable({
    providedIn: 'root',
})
export class GetUnreadNotificationsMapper
    implements
    BaseMapper<DataResponseModel<NotificationUnreadModel[]>, DataResponseHttp<NotificationUnreadHttp[]>>
{

    convertFrom(
        http: DataResponseHttp<NotificationUnreadHttp[]>
    ): DataResponseModel<NotificationUnreadModel[]> {

        let response = {
            isError: http.isError,
            errors: http.errors,
            data: []
        } as DataResponseModel<NotificationUnreadModel[]>;
        if(http.isError!=true && http.data){
            for(var itemHttp of http.data){
                response.data.push({
                    id: itemHttp.id,
                    title: itemHttp.title,
                    description: itemHttp.description,
                    type: itemHttp.type,
                    s3FileKey: itemHttp.s3FileKey,
                    redirectUrl: itemHttp.redirectUrl,
                    updatedBy: itemHttp.updatedBy,
                    updatedDateUtc: new Date(itemHttp.updatedDateUtc),
                    loading: false,
                    isRead: false
                });
            }

        }
        return response;
    }
}
